import {
  merchantDashboardIdFormat,
  merchantDashboardWidgetIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import {
  MerchantDashboardNameSchema,
  MerchantDashboardSummarySchema,
} from "./merchant-dashboard-fields";

export const updateMerchantDashboard = {
  name: "updateMerchantDashboard" as const,
  input: z.object({
    dashboardId: merchantDashboardIdFormat.schema,
    name: MerchantDashboardNameSchema.optional(),
    widgetIds: z
      .array(merchantDashboardWidgetIdFormat.schema)
      .min(1)
      .optional(),
  }),
  output: z.object({ dashboard: MerchantDashboardSummarySchema }),
};
